import React from 'react';
import PropTypes from 'prop-types';

import DefaultPicture, {
  propTypes as defaultPicturePropTypes,
} from '../../../01_atoms/DefaultPicture';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';
import BlockFooter from '../../../02_molecules/BlockFooter';
import { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import FormattedText from '../../../01_atoms/FormattedText';

import styles from './index.module.scss';

const BBMovingImageCollage = ({
  heading = '',
  subheading = '',
  images,
  buttonDescription = '',
  button = null,
  behaviorSettings = null,
  uuid = null,
}) => {
  // Eventually we need a list of elements with 3 blocks with equal amount of items.
  // 1st and 3rd block will be the same, to make new loop of animation looks smooth for users.
  // Size of the block is 8 items: 4 columns with 2 items in each column.
  // We need to fill the bocks with available images.
  // Preparing even amount of images for filling the first two blocks.
  const evenImages = [...images];
  // Dropping last odd element, if it exists.
  if (evenImages.length % 2 !== 0) {
    evenImages.splice(-1);
  }
  // Filing the first two blocks.
  let gridImages = [...evenImages];
  while (gridImages.length < 16) {
    gridImages.push(...evenImages);
  }
  // Removing extra elements.
  gridImages = gridImages.slice(0, 16);
  // Filling the third block by the same elements as in the first block.
  // Adding 2 more extra columns to avoid showing empty space when animation start new cycle.
  // These two columns won't be included in final length of animation track,
  // but still be visible to users, which is exactly what we need.
  gridImages.push(...gridImages.slice(0, 12));

  const classes = [
    'bb',
    styles['bb-moving-image-collage'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div id={uuid} className={classes.join(' ')}>
      <div className={`${styles['bb-moving-image-collage__images']}`}>
        <div className={`${styles['bb-moving-image-collage__grid']}`}>
          {gridImages.map((item, index) => (
            <div key={index} className={`${styles['bb-moving-image-collage__image-box']}`}>
              <DefaultPicture {...item} />
            </div>
          ))}
        </div>
      </div>

      {(heading || subheading) && (
        <div className={`${styles['bb-moving-image-collage__title-group']}`}>
          <div className="container">
            {heading && (
              <h2 className={`${styles['bb-moving-image-collage__title']}`}>{heading}</h2>
            )}
            {subheading && (
              <FormattedText
                className={styles['bb-moving-image-collage__subtitle']}
                text={subheading}
              />
            )}
          </div>
        </div>
      )}

      {button && button.nextLink && (
        <div className={`${styles['bb-moving-image-collage__footer']}`}>
          <div className="container">
            <div className={`${styles['bb-moving-image-collage__footer-content']}`}>
              <BlockFooter button={button} buttonDescription={buttonDescription} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

BBMovingImageCollage.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape(defaultPicturePropTypes)).isRequired,
  buttonDescription: PropTypes.string,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    nextLink: PropTypes.shape(linkPropTypes).isRequired,
  }),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBMovingImageCollage;
